var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('apexchart',{attrs:{"width":"550","type":"bar","options":_vm.chartOptions,"series":_vm.series}}),_c('div',[_c('button',{on:{"click":_vm.updateChart}},[_vm._v("Update!")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }